function showBlock(options) {
  const {
    selector,
    storageKey,
    expiredKey,
    displayHours = 24,
    isAnimation = true
  } = options;

  const block = document.querySelector(selector);
  if (!block) return;

  const DURATION = displayHours * 60 * 60 * 1000;
  const now = Date.now();

  if (localStorage.getItem(expiredKey) === 'true') {
    return;
  }

  const firstVisit = localStorage.getItem(storageKey);

  if (!firstVisit) {
    localStorage.setItem(storageKey, now.toString());
    revealBlock(block);
    return;
  }

  const timePassed = now - parseInt(firstVisit, 10);

  if (timePassed < DURATION) {
    revealBlock(block);
  } else {
    localStorage.setItem(expiredKey, 'true');
  }

  function revealBlock(el) {
    el.classList.add('is-visible');

    if(!isAnimation) return;
    
    el.style.maxHeight = '0px';
    requestAnimationFrame(() => {
      el.style.maxHeight = el.scrollHeight + 'px';
    });
  }
}